var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.71 3.296a1 1 0 0 1 .241 1.012l-5.5 17a1 1 0 0 1-1.833.163L9.756 14.23l-7.243-4.043a1 1 0 0 1 .189-1.828l17-5.313a1 1 0 0 1 1.009.25Zm-8.979 10.387 2.543 4.768L17.77 7.644l-6.039 6.04Zm4.688-7.516-10.9 3.407 4.808 2.684z",
    clipRule: "evenodd"
  })));
};
export default SvgSend;